

import Cookies from 'js-cookie';


const API = require('./C2API')
const Auth = require('./C2Auth')

const configure = (config) => {
    console.log(config)
    API.configure(config.API)
    Auth.configure(config.Auth)
} 



const setJwtToken = async (jwtToken) => {
   await  API.setJwtToken(jwtToken);
    // await API.setJwtToken('gwapi', jwtToken);
    // await API.setJwtToken('api', jwtToken);
}



const setUser = async (user) => {
    await Auth.setUser(user)
}


const setupApi = async (config) => {
    API.configure({
        endpoints: [
            {
                name: 'api',
                endpoint: (config['PRIV_PLAT_API'] || '').replace(/\/$/, ''),
                service: 'discover'
            },
            {
                name: 'gwapi',
                endpoint: config['API_URL'],
                service: 'aws-gateway'
            },
            {
                name: 'manager',
                endpoint: config['MANAGE_API'],
                service: 'manager'
            },
            {
                name: 'integrations',
                endpoint: config['INTEGRATIONS_API'],
                service: 'integrations'
            },
            {
                name: 'discoverRuns',
                endpoint: (config['PRIV_PLAT_API'] || '').replace(/\/$/, ''),
                service: 'discover-runs'
            }
        ]
    });
}

// The session cookie's name in one place — the render gate below and the logout path both
// read it, and they must agree on what "signed in" means.
const SESSION_COOKIE = "c2-discover-api-token";

/**
 * Is a session cookie still present? Cheap and synchronous, for checks that run on every
 * page restore. False does not prove the token is valid, only that there is nothing to
 * present — which is enough to stop rendering a signed-in page.
 */
const hasSessionCookie = () => {
    try {
        return !!Cookies.get(SESSION_COOKIE);
    } catch (err) {
        // Cookies blocked entirely: treat as signed out rather than assume a session.
        return false;
    }
}

const loadCookieAndValidate = async () => {
    try {
        let cookieValue = Cookies.get(SESSION_COOKIE)
        if (cookieValue) {
            let userData = await API.post('api', '/users/validate', { token: cookieValue });
            return userData;
        }
    }
    catch (err) { console.log('user data err', err) }
    return null;
}

const changePassword = async (currentPassword, newPassword) => {
    // Backend derives the target user from the authenticated JWT; only the
    // current + new password are sent.
    return await API.post('api', '/users/change-password', {
        currentPassword,
        newPassword
    });
}

const logout = async () => {
    try {
        // Call the logout API endpoint
        await API.post('api', '/users/logout');
    } catch (err) {
        // Log the error but don't throw - logout should work even if API call fails
        console.log('logout API call failed (this is ok if logout endpoint not deployed yet):', err);
    }
    
    // Clear JWT token from all endpoints
    await API.setJwtToken(null);
    
    // Clear user data
    await Auth.setUser(null);
    
    // Clear the cookie
    Cookies.remove(SESSION_COOKIE);
}

export {
    setupApi,
    loadCookieAndValidate,
    hasSessionCookie,
    SESSION_COOKIE,
    setJwtToken,
    setUser,
    logout,
    changePassword,
    API,
    Auth,
    configure
}